// extracted by mini-css-extract-plugin
export var currency = "pages-account-purchase-__ApplyStoredValueOption-module___currency";